/**
* ปริมณฑล — นนทบุรี ปทุมธานี สมุทรปราการ นครปฐม สมุทรสาคร
*/
import { branch, type Branch } from "./types";

export const VICINITY_BRANCHES: Branch[] = [
  branch({
    id: "nonthaburi-westgate",
    name: "สาขานนทบุรี (เซ็นทรัล เวสต์เกต บางใหญ่)",
    shortName: "เซ็นทรัล เวสต์เกต",
    street: "",
    meetingPoint: "ศูนย์การค้าเซ็นทรัล เวสต์เกต ถนนกาญจนาภิเษก",
    locality: "ตำบลเสาธงหิน อำเภอบางใหญ่",
    region: "นนทบุรี",
    postalCode: "11140",
    geo: { lat: 13.8740, lng: 100.4110 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "nonthaburi",
    landmarks: ["อิเกีย บางใหญ่", "ตลาดบางใหญ่"],
    transit: ["MRT สายสีม่วง สถานีตลาดบางใหญ่"],
  }),
  branch({
    id: "nonthaburi-westville",
    name: "สาขานนทบุรี (เซ็นทรัล เวสต์วิลล์ ราชพฤกษ์)",
    shortName: "เซ็นทรัล เวสต์วิลล์",
    street: "",
    meetingPoint: "ศูนย์การค้าเซ็นทรัล เวสต์วิลล์ ถนนราชพฤกษ์",
    locality: "ตำบลมหาสวัสดิ์ อำเภอบางกรวย",
    region: "นนทบุรี",
    postalCode: "11130",
    geo: { lat: 13.8060, lng: 100.4310 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "nonthaburi",
    landmarks: ["โฮมโปร ราชพฤกษ์", "เดอะคริสตัล เอสบี ราชพฤกษ์"],
    transit: ["ใกล้ทางด่วนศรีรัช"],
  }),
  branch({
    id: "nonthaburi-nichada",
    name: "จุดบริการนิชดาธานี ปากเกร็ด (ชุมชน Expat)",
    shortName: "นิชดาธานี ปากเกร็ด",
    street: "",
    locality: "อำเภอปากเกร็ด",
    region: "นนทบุรี",
    postalCode: "11120",
    geo: { lat: 13.9130, lng: 100.5290 },
    branchType: "expat-hub",
    provinceSlug: "nonthaburi",
    landmarks: ["โรงเรียนนานาชาติ ISB", "เมืองทองธานี"],
    transit: ["ใกล้ทางด่วนแจ้งวัฒนะ"],
    serviceFocus: ["notary", "translation", "naati", "visa", "longstay", "marriage"],
    serviceAreaOnly: true,
    note: "ชุมชนชาวต่างชาติที่ใหญ่ที่สุดในไทย รองรับเอกสารโรงเรียนนานาชาติและวีซ่าติดตามครอบครัว",
  }),
  branch({
    id: "nonthaburi-dbd-sanambinnam",
    name: "จุดบริการสนามบินน้ำ (กรมพัฒนาธุรกิจการค้า DBD)",
    shortName: "สนามบินน้ำ DBD",
    street: "",
    meetingPoint: "ถนนนนทบุรี",
    locality: "ตำบลบางกระสอ อำเภอเมืองนนทบุรี",
    region: "นนทบุรี",
    postalCode: "11000",
    geo: { lat: 13.8460, lng: 100.5140 },
    serviceAreaOnly: true,
    branchType: "government",
    provinceSlug: "nonthaburi",
    landmarks: ["กรมพัฒนาธุรกิจการค้า (DBD)", "กรมทรัพย์สินทางปัญญา (DIP)"],
    transit: ["MRT สายสีม่วง สถานีศรีพรสวรรค์ (ต่อรถ)"],
    serviceFocus: ["corporate", "translation", "notary", "lgz"],
    note: "คัดหนังสือรับรองบริษัทและแปลเอกสารนิติบุคคลเพื่อใช้ต่างประเทศ",
  }),
  branch({
    id: "pathum-thani-futurepark",
    name: "สาขาปทุมธานี (ฟิวเจอร์พาร์ค รังสิต)",
    shortName: "ฟิวเจอร์พาร์ค รังสิต",
    street: "",
    meetingPoint: "ศูนย์การค้าฟิวเจอร์พาร์ค รังสิต ถนนพหลโยธิน",
    locality: "ตำบลประชาธิปัตย์ อำเภอธัญบุรี",
    region: "ปทุมธานี",
    postalCode: "12130",
    geo: { lat: 13.9890, lng: 100.6170 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "pathum-thani",
    landmarks: ["เมเจอร์ รังสิต", "มหาวิทยาลัยรังสิต"],
    transit: ["SRT สายสีแดง สถานีรังสิต"],
  }),
  branch({
    id: "pathum-thani-navanakorn",
    name: "จุดบริการนวนคร (นิคมอุตสาหกรรม)",
    shortName: "นวนคร",
    street: "",
    meetingPoint: "โลตัส นวนคร ถนนพหลโยธิน",
    locality: "ตำบลคลองหนึ่ง อำเภอคลองหลวง",
    region: "ปทุมธานี",
    postalCode: "12120",
    geo: { lat: 14.0800, lng: 100.6100 },
    serviceAreaOnly: true,
    branchType: "expat-hub",
    provinceSlug: "pathum-thani",
    landmarks: ["นิคมอุตสาหกรรมนวนคร", "มหาวิทยาลัยราชภัฏวไลยอลงกรณ์"],
    transit: ["ถนนพหลโยธิน กม.46"],
    serviceFocus: ["corporate", "visa", "translation", "notary", "immigration"],
  }),
  branch({
    id: "pathum-thani-chiang-rak",
    name: "จุดบริการเชียงราก (มธ.ศูนย์รังสิต)",
    shortName: "เชียงราก / มธ.รังสิต",
    street: "",
    meetingPoint: "ถนนเชียงราก",
    locality: "ตำบลคลองหนึ่ง อำเภอคลองหลวง",
    region: "ปทุมธานี",
    postalCode: "12120",
    geo: { lat: 14.0720, lng: 100.6060 },
    serviceAreaOnly: true,
    branchType: "expat-hub",
    provinceSlug: "pathum-thani",
    landmarks: ["มหาวิทยาลัยธรรมศาสตร์ ศูนย์รังสิต", "ตลาดไท"],
    transit: ["SRT สายสีแดง สถานีมหาวิทยาลัยธรรมศาสตร์"],
    serviceFocus: ["translation", "notary", "visa", "sworn"],
  }),
  branch({
    id: "samut-prakan-megabangna",
    name: "สาขาสมุทรปราการ (เมกาบางนา)",
    shortName: "เมกาบางนา",
    street: "",
    meetingPoint: "ศูนย์การค้าเมกาบางนา ถนนบางนา-ตราด",
    locality: "ตำบลบางแก้ว อำเภอบางพลี",
    region: "สมุทรปราการ",
    postalCode: "10540",
    geo: { lat: 13.6460, lng: 100.6820 },
    serviceAreaOnly: true,
    branchType: "mall",
    provinceSlug: "samut-prakan",
    landmarks: ["อิเกีย บางนา", "ไทวัสดุ บางนา"],
    transit: ["BTS อุดมสุข (มี Shuttle Bus ฟรี)"],
  }),
  branch({
    id: "samut-prakan-suvarnabhumi",
    name: "จุดบริการท่าอากาศยานสุวรรณภูมิ",
    shortName: "สุวรรณภูมิ",
    street: "",
    meetingPoint: "ท่าอากาศยานสุวรรณภูมิ อาคารผู้โดยสาร",
    locality: "ตำบลหนองปรือ อำเภอบางพลี",
    region: "สมุทรปราการ",
    postalCode: "10540",
    geo: { lat: 13.6900, lng: 100.7501 },
    serviceAreaOnly: true,
    branchType: "airport",
    provinceSlug: "samut-prakan",
    landmarks: ["จุดตรวจคนเข้าเมือง (ตม.)", "เคาน์เตอร์บริการนักท่องเที่ยว"],
    transit: ["ARL สุวรรณภูมิ"],
    serviceFocus: ["notary", "translation", "visa", "immigration", "lgz"],
  }),
  branch({
    id: "nakhon-pathom-salaya",
    name: "จุดบริการศาลายา (ม.มหิดล)",
    shortName: "ศาลายา",
    street: "",
    meetingPoint: "ถนนพุทธมณฑลสาย 4",
    locality: "ตำบลศาลายา อำเภอพุทธมณฑล",
    region: "นครปฐม",
    postalCode: "73170",
    geo: { lat: 13.7940, lng: 100.3230 },
    serviceAreaOnly: true,
    branchType: "expat-hub",
    provinceSlug: "nakhon-pathom",
    landmarks: ["มหาวิทยาลัยมหิดล ศาลายา", "เซ็นทรัล ศาลายา"],
    transit: ["SRT สายสีแดงอ่อน (อนาคต)"],
    serviceFocus: ["translation", "sworn", "notary", "visa"],
  }),
  branch({
    id: "samut-sakhon-mahachai-labour",
    name: "จุดบริการศูนย์แรงงานต่างด้าว มหาชัย",
    shortName: "มหาชัย (แรงงานต่างด้าว)",
    street: "",
    locality: "ตำบลท่าจีน อำเภอเมืองสมุทรสาคร",
    region: "สมุทรสาคร",
    postalCode: "74000",
    geo: { lat: 13.5450, lng: 100.2740 },
    branchType: "government",
    provinceSlug: "samut-sakhon",
    landmarks: ["ศูนย์บริการแรงงานต่างด้าวมหาชัย", "ตลาดทะเลไทย"],
    transit: ["รถไฟสายมหาชัย สถานีมหาชัย"],
    serviceFocus: ["visa", "immigration", "translation", "notary"],
    serviceAreaOnly: true,
    note: "ศูนย์กลางเอกสารและวีซ่าแรงงานเมียนมา/กัมพูชาที่ใหญ่ที่สุดในภาคกลาง",
  }),
];
